<template>
<div v-if="form">
    <v-toolbar flat color="white">
        <v-toolbar-title>
            <v-icon class="mr-1">description</v-icon>{{form.name}}
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn v-if="!editing" small @click="editing=true" icon>
            <v-icon small>edit</v-icon>
        </v-btn>
        <v-btn v-if="editing" small @click="editing=false, updateForm()" icon>
            <v-icon small color="green">check</v-icon>
        </v-btn>
    </v-toolbar>
    <v-layout justify-center>
        <v-flex xs8 class="text-xs-center">
            <v-list three-line subheader>
                <span class="text-xs-center" v-if="!editing&&form.description">{{form.description}}</span>
                <v-text-field v-if="editing" v-model="form.description" box placeholder="Description"></v-text-field>
                <v-subheader style="width: 100%;background: #f0f0f0">Fields:</v-subheader>
                <v-list subheader dense style="width: 100%" v-if="!editing">
                    <draggable v-model="form.formFields" :options='{group: "formFields"}' @change="change">
                        <v-list-tile style="border: 1px solid lightgrey; border-radius: 5px" v-for="field in form.formFields" :key="field.id">
                            <v-list-tile-action class="ml-0 pl-0" style="width: 100px">
                                <v-layout justify-start>
                                    <v-flex xs4>
                                        <v-btn icon small>
                                            <v-icon>drag_indicator</v-icon>
                                        </v-btn>
                                    </v-flex>
                                    <v-flex xs4>
                                        <v-tooltip top>
                                            <template v-slot:activator="{ on }">
                                                <v-btn v-on="on" small icon>
                                                    <v-icon :color="field.required?'blue':'grey'">verified</v-icon>
                                                </v-btn>
                                            </template>
                                            <span>Required Field</span>
                                        </v-tooltip>
                                    </v-flex>
                                     <v-flex xs4 v-if="field.function">
                                        <v-tooltip top>
                                            <template v-slot:activator="{ on }">
                                                <v-btn v-on="on" small icon>
                                                    <v-icon :color="field.function?'orange':'grey'">functions</v-icon>
                                                </v-btn>
                                            </template>
                                            <span>Attached function</span>
                                        </v-tooltip>
                                    </v-flex>
                                </v-layout>
                            </v-list-tile-action>
                            <v-list-tile-content>
                                <v-list-tile-title style="font-size: 12px">
                                    {{field.name}}
                                </v-list-tile-title>
                                <v-list-tile-sub-title v-if="field.hint" style="font-size: 12px">
                                    {{field.hint}}
                                </v-list-tile-sub-title>
                            </v-list-tile-content>
                            <v-list-tile-action>
                                <v-chip v-if="field.formFieldOptions.length>0" small outline>
                                    {{field.formFieldOptions.length}} Selections
                                </v-chip>
                            </v-list-tile-action>
                        </v-list-tile>
                    </draggable>
                </v-list>
                <!-- <v-list three-line>
                     <v-list-tile style="border: 1px solid lightgrey; border-radius: 5px" v-for="field in form.formFields" :key="field.id">
                            <v-list-tile-action class="ml-0 pl-0" style="width: 100px">
                                <v-layout>
                                    <v-flex>
                                        <v-btn icon small>
                                            <v-icon>drag_indicator</v-icon>
                                        </v-btn>
                                    </v-flex>
                                    <v-flex>
                                        <v-tooltip top>
                                            <template v-slot:activator="{ on }">
                                                <v-btn v-on="on" small icon @click="updateRequiredField(field)">
                                                <v-icon :color="field.required?'blue':'grey'">verified</v-icon>
                                            </v-btn>
                                            </template>
                                            <span>Required Field</span>
                                        </v-tooltip>
                                    </v-flex>
                                     <v-flex >
                                        <v-tooltip top>
                                            <template v-slot:activator="{ on }">
                                                 <v-btn v-on="on" small icon @click="updateFunctionField(field)">
                                                <v-icon :color="field.required?'orange':'grey'">functions</v-icon>
                                            </v-btn>
                                            </template>
                                            <span>Attached function</span>
                                        </v-tooltip>
                                    </v-flex>
                                </v-layout>
                            </v-list-tile-action>
                            <v-list-tile-content>
                                <v-list-tile-title style="font-size: 12px">
                                    {{field.name}}
                                </v-list-tile-title>
                                <v-list-tile-sub-title v-if="field.hint" style="font-size: 12px">
                                    {{field.hint}}
                                </v-list-tile-sub-title>
                            </v-list-tile-content>
                            <v-list-tile-action>
                                <v-chip v-if="field.formFieldOptions.length>0" small outline>
                                    {{field.formFieldOptions.length}} Selections
                                </v-chip>
                            </v-list-tile-action>
                        </v-list-tile>
                </v-list> -->
                <draggable v-if="editing" v-model="form.formFields" :key="fieldKey" :options='{group: "formFields"}' @change="change">
                    <v-card flat style="border-radius: 5px; border: 1px solid grey; width:100%; padding: 5px;" v-for="(field, index) in form.formFields" :key="field.id">
                        <v-card-text style="padding: 0; margin: 0">
                            <v-layout wrap align-center justify-center>
                                <v-flex xs2>
                                      <v-layout justify-start>
                                    <v-flex xs4>
                                    <v-btn icon small>
                                        <v-icon>drag_indicator</v-icon>
                                    </v-btn>
                                    </v-flex>
                                    <v-flex xs4>
                                    <v-tooltip top>
                                        <template v-slot:activator="{ on }">
                                            <v-btn v-on="on" small icon @click="updateRequiredField(field)">
                                                <v-icon :color="field.required?'blue':'grey'">verified</v-icon>
                                            </v-btn>
                                        </template>
                                        <span>Required Field</span>
                                    </v-tooltip>
                                    </v-flex>
                                     <v-flex xs4 v-if="field.type == 'Selection'">
                                        <v-tooltip top>
                                            <template v-slot:activator="{ on }">
                                                 <v-btn v-on="on" small icon @click="updateFunctionField(field)">
                                                <v-icon :color="field.function?'orange':'grey'">functions</v-icon>
                                            </v-btn>
                                            </template>
                                            <span>Attached function</span>
                                        </v-tooltip>
                                    </v-flex>
                                      </v-layout>
                                </v-flex>
                                <v-flex xs8 style="height:80px; padding:0; margin:0; padding-bottom: 5px">
                                    <v-layout wrap class="ma-0 pa-0">
                                        <v-flex xs5 mx-1 pb-1>
                                            <v-text-field color="black" placeholder="Field Title" v-on:blur="updateField(field)" v-model="field.name" class="ma-0 pa-0" hide-details style="font-weight: bold;font-size: 12px; width: 100%; margin: 0; padding: 0;"></v-text-field>
                                            <v-text-field color="black" placeholder="Hint (optional)" v-on:blur="updateField(field)" v-model="field.hint" class="ma-0 pa-0" hide-details style="font-size: 12px; width: 100%; margin:0; padding: 0"></v-text-field>
                                        </v-flex>
                                        <v-flex xs5 mx-1 pb-1>
                                            <v-select flat  style="font-size: 12px; width: 100%; margin:0; padding: 0" @change="updateField(field)" hide-details class="ma-0 pa-0" dense :items="selectOptions" placeholder="Input Type" v-model="field.type"></v-select>
                                            <v-autocomplete v-if="field.type == 'Selection' && field.function" :ref="'function_'+index" color="black" clearable v-on:blur="$refs['function_'+index].blur()" flat :items="sharedFunctions" style="height:20px;font-size: 12px; width: 100%; margin:0; padding: 0" hide-details item-text="name" item-value="value" @change="updateField(field)" dense placeholder="Attached Function" v-model="field.functionValue"></v-autocomplete>
                                        </v-flex>
                                    </v-layout>
                                </v-flex>
                                <v-flex xs2 class="text-xs-center">
                                    <v-layout justify-center v-if="editing">
                                        <v-tooltip bottom>
                                            <template v-slot:activator="{ on }">
                                                <v-btn v-on="on" small class="mx-0" icon @click="removeField(field)">
                                                    <v-icon small>close</v-icon>
                                                </v-btn>
                                            </template>
                                            <span>Remove</span>
                                        </v-tooltip>
                                    </v-layout>

                                </v-flex>
                                <v-flex xs12 v-if="field.type == 'Selection' && !field.function">
                                    <v-list subheader dense style="width: 100%">
                                        <v-subheader style="width: 100%;background: #f0f0f0">Selection Options</v-subheader>
                                        <draggable v-model="field.formFieldOptions" :options='{group: "formFieldOptions"}' @change="changeOption(field)">
                                            <v-list-tile style="border-radius: 5px" v-for="option in field.formFieldOptions" :key="option.id">
                                                <v-list-tile-action class="ml-0 pl-0">
                                                    <v-layout>
                                                        <v-flex>
                                                            <v-btn icon small>
                                                                <v-icon>drag_indicator</v-icon>
                                                            </v-btn>
                                                        </v-flex>
                                                    </v-layout>
                                                </v-list-tile-action>
                                                <v-list-tile-content>
                                                    <v-text-field :ref="'option_'+option.index" color="black" v-on:blur="updateFieldOption(option)" v-model="option.name" flat solo class="ma-0 pa-0" hide-details style="font-size: 12px; width: 100%"></v-text-field>
                                                </v-list-tile-content>
                                                <v-list-tile-action>
                                                    <v-tooltip bottom>
                                                        <template v-slot:activator="{ on }">
                                                            <v-btn v-on="on" small class="mx-0" icon @click="removeFieldOption(field, option)">
                                                                <v-icon small>close</v-icon>
                                                            </v-btn>
                                                        </template>
                                                        <span>Remove</span>
                                                    </v-tooltip>
                                                </v-list-tile-action>
                                            </v-list-tile>
                                        </draggable>
                                        <v-layout justify-center>
                                            <v-btn outline small style="border-radius: 5px" color="blue" @click="addFieldOption(field)">
                                                <v-icon class='mr-1' small>add</v-icon> Add Option
                                            </v-btn>
                                        </v-layout>
                                    </v-list>
                                </v-flex>
                                <v-flex xs12 v-else-if="field.type == 'Selection'">

                                </v-flex>
                            </v-layout>
                        </v-card-text>
                    </v-card>
                </draggable>
                <v-layout justify-center v-if="editing">
                    <v-btn color="black" class="white--text" small style="border-radius: 5px" @click="addField()">
                        <v-icon class='mr-1' small>add</v-icon> Add Field
                    </v-btn>
                </v-layout>
            </v-list>
        </v-flex>
        <v-flex xs4 class="px-2">
            <v-subheader style="width: 100%;background: #f0f0f0;">Form Preview: {{form.name}}</v-subheader>
            <v-card>
                <small>{{form.description}}</small>
                <v-card-text>
                    <v-layout wrap :key="fieldKey">
                        <v-flex xs12 v-for="field in form.formFields" :key="field.id">
                            <v-text-field v-if="field.type == 'Text Field'" :placeholder="field.name" :hint="field.hint" style="font-size: 12px; width: 100%; margin:0; padding: 0"></v-text-field>
                            <v-checkbox style="font-size: 12px; width: 100%; margin:0; padding: 0" v-else-if="field.type=='Checkbox'" :label="field.name">
                                <template v-slot:label>
                                    <span style="font-size: 12px">{{field.name}}</span>
                                </template>
                            </v-checkbox>
                            <v-select style="font-size: 12px; width: 100%; margin:0; padding: 0" :placeholder="field.name" dense clearable v-else-if="field.type=='Selection'" :items="field.formFieldOptions" item-text="name" item-value="name">
                            </v-select>
                            <div v-else-if="field.type == 'Image Upload'" style="width: 100%; height: 90px" :class="['dropZone', dragging ? 'dropZone-over' : '']" @dragenter="dragging = true" @dragleave="dragging = false">
                                <div class="dropZone-info" @drag="onFileChange(field)">
                                    <span class="dropZone-title" style="font-size: 12px; cursor: pointer">Media Upload: {{field.name}}</span>
                                </div>
                                <input ref="fileUpload" type="file" @change="onFileChange($event, field)">
                            </div>
                        </v-flex>
                    </v-layout>
                </v-card-text>
            </v-card>
        </v-flex>

    </v-layout>
</div>
</template>

<script>
import Api from "@/services/Api";
import draggable from "vuedraggable";
export default {
    components: {
        draggable
    },
    data: () => ({
        dragging: false,
        editing: false,
        form: null,
        fieldKey: 0,
        selectOptions: ['Checkbox', 'Image Upload', 'Selection', 'Text Field'],
        sharedFunctions: []
    }),
    created() {
        this.getForm()
        this.fetchSharedFunctions()
    },
    methods: {
        addField() {
            let index = 0
            if (this.form.formFields) {
                index = this.form.formFields.length
            }
            Api().post('/formField', {
                index: index,
                formId: this.$route.params.id
            }).then(res => {
                res.data.formFieldOptions = []
                this.form.formFields.push(res.data)
                this.fieldKey++
            })
        },
        addFieldOption(field) {
            let index = 0
            if (field.formFieldOptions.length > 0) {
                index = Math.max(...field.formFieldOptions.map(x => x.index)) + 1;
                if ((index - 1) < field.formFieldOptions.length) {
                    index = field.formFieldOptions.length
                }
            }
            Api().post('/formFieldOption', {
                index: index,
                formFieldId: field.id
            }).then(res => {
                field.formFieldOptions.push(res.data)
                this.fieldKey++
                this.$nextTick(() => this.$nextTick(() => this.$refs['option_' + index][0].focus()))

            })
        },
        async change(event) {
            for (let i = 0; i < this.form.formFields.length; i++) {
                this.form.formFields[i].index = i
            }
            let data = this.form.formFields.map(x => ({
                id: x.id,
                index: x.index
            }))
            this.updateFieldIndices(data)
        },
        async changeOption(field) {
            for (let i = 0; i < field.formFieldOptions.length; i++) {
                field.formFieldOptions[i].index = i
            }
            let data = field.formFieldOptions.map(x => ({
                id: x.id,
                index: x.index
            }))
            this.updateFieldOptionIndices(data)
        },
        getForm() {
            Api().get('/form/' + this.$route.params.id).then(res => {
                this.form = res.data
            })
        },
         fetchSharedFunctions(){
            Api().get('/sharedFunctions').then(res=>{
                let keys = Object.keys(res.data)
                this.sharedFunctions = keys.map(x=>({name: res.data[x].name, description: res.data[x].description, value: x, parameters: res.data[x].parameters, tag: res.data[x].tag}))
            })
        },
        onFileChange(e, field) {
            var files = e.target.files || e.dataTransfer.files;
            if (!files.length) {
                this.dragging = false;
                return;
            }
            this.createFile(files[0], field);
        },
        async createFile(file) {
            // if (!file.type.match('text.*')) {
            //     alert('please select txt file');
            //     this.dragging = false;
            //     return;
            // }

            if (file.size > 5000000) {
                alert('please check file size no over 5 MB.')
                this.dragging = false;
                return;
            }

            this.file = file;
            var reader = new FileReader();
            await reader.readAsBinaryString(this.file);
            reader.onload = () => {
                file = btoa(reader.result)
                field.base64 = file;
                // this.uploadDocument(this.file)
            }

            this.dragging = false;
        },
        removeField(item) {
            Api().put('/formField/' + item.id, {
                isActive: false,
                isDeleted: true
            }).then(res => {
                // this.form.formFields.push(res.data)
                this.form.formFields.splice(this.form.formFields.indexOf(item), 1)
                this.fieldKey++

            })
        },
        removeFieldOption(field, option) {
            Api().put('/formFieldOption/' + option.id, {
                isActive: false,
                isDeleted: true
            }).then(res => {
                // this.form.formFields.push(res.data)
                field.formFieldOptions.splice(field.formFieldOptions.indexOf(option), 1)
                this.fieldKey++

            })
        },
        updateFieldIndices(data) {
            Api().post('/formField/index', data).then(res => {})
        },
        updateField(item) {
            Api().put('/formField/' + item.id, item).then(res => {
                // this.form.formFields.push(res.data)
            })
        },
        updateFieldOption(option) {
            Api().put('/formFieldOption/' + option.id, option).then(res => {
                this.fieldKey++
            })
        },
        updateFieldOptionIndices(option) {
            Api().post('/formFieldOption/index', option).then(res => {
                this.fieldKey++
            })
        },
        updateRequiredField(item) {
            item.required = !item.required
            Api().put('/formField/' + item.id, item).then(res => {
                // this.form.formFields.push(res.data)
            })
        },
        updateFunctionField(item) {
            item.function = !item.function
            Api().put('/formField/' + item.id, item).then(res => {
                // this.form.formFields.push(res.data)
            })
        },
        updateForm(){
            Api().put('/form/' + this.form.id, this.form).then(res => {
            })
        }
    }
}
</script>

<style scoped>
.dropZone {
    width: 180px;
    height: 90%;
    /* position: relative; */
    border: 2px dashed #eee;
}

.dropZone:hover {
    border: 2px solid #2e94c4;
}

.dropZone:hover .dropZone-title {
    color: #1975A0;
}

.dropZone-info {
    color: #A8A8A8;
    position: absolute;
    top: 50%;
    width: 100%;
    transform: translate(0, -50%);
    text-align: center;
}

.dropZone-title {
    color: #787878;
}

.dropZone input {
    position: absolute;
    cursor: pointer;
    top: 0px;
    right: 0;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 100%;
    opacity: 0;
}

.dropZone-upload-limit-info {
    display: flex;
    justify-content: flex-start;
    flex-direction: column;
}

.dropZone-over {
    background: #5C5C5C;
    opacity: 0.8;
}

.dropZone-uploaded {
    width: 80%;
    height: 200px;
    position: relative;
    border: 2px dashed #eee;
}

.dropZone-uploaded-info {
    display: flex;
    flex-direction: column;
    align-items: center;
    color: #A8A8A8;
    position: absolute;
    top: 50%;
    width: 100%;
    transform: translate(0, -50%);
    text-align: center;
}
</style>
